  <!-- main app container -->
  <div class="card m-3"> 
    <div class="card-body">


      <h2><img src="./assets/manufacture.png" width="70px"> Manufacturers</h2>

      <a routerLink="/manufacturers/add">
        <button mat-button color="success"><mat-icon>add</mat-icon>ADD</button></a>
      <div class="mat-elevation-z8">
       
        <br>
        <table class="table table-striped table-sm">
    <thead>
      <tr>
        <th>Name</th>
        <th *ngIf="!isMobile">Country</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let manufacturer of manufacturers">
        <td>{{ manufacturer.name }}</td>
        <td *ngIf="!isMobile">{{ manufacturer.country }}</td>
        <td>
          <button (click)="editManufacturer(manufacturer)">Edit</button>
          <button (click)="delete(manufacturer)" style="margin-left: 10px;">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>
  </div></div>